import dayJS from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import isBetween from 'dayjs/plugin/isBetween'
dayJS.extend(isBetween)
dayJS.extend(utc)
dayJS.extend(timezone)
dayJS.tz.setDefault('Asia/Bangkok')
